module.exports = __webpack_public_path__ + "img/transportationDetail.6e005a04.svg";